const { AllSocialMedia } = require("../features/admin/common/Slice");

exports.APIS = {
  Auth: "/common/auth/admin-login",
  ChangePassword: "/common/auth/change-password",

  

  Masters: {
    Country: "/admin/masters/country",
    State: "/admin/masters/state",
    City: "/admin/masters/city",
    Pincode: "/admin/masters/pincode",
    AvgMonthlyBill: "/admin/masters/avgmonthlybill",
    TrustedAcrossCommunity: "/admin/masters/trustedacrosscommunity"
  },


  //FAQ
  Faqs: {
    FAQ: "/admin/faqs/faq",
    FAQCategory: "/admin/faqs/faqcategory"
  },


  //Blogs
  Blogs: {
    PopularTag: "/admin/blogs/populartag",
    Blog: "/admin/blogs/blog",
    GetStarted: "/admin/blogs/getstarted"
  },


  //Services
  Services: {
    ServiceInclude: "/admin/services/serviceinclude",
    KeyBenefit: "/admin/services/keybenefit",
    BestFor: "/admin/services/bestfor",
    Service: "/admin/services/service"
  },


  //AboutUs
  Aboutus: {
    Banner: "/admin/aboutus/banner",
    VisionMission: "/admin/aboutus/visionmission",
    WhyChooseUs: "/admin/aboutus/whychooseus",
    PeopleBehindWork: "/admin/aboutus/peoplebehindwork",
    WhyWeRank: "/admin/aboutus/whywerank",
    WhatMakeDifferent: "/admin/aboutus/whatmakedifferent",
    WeFocus: "/admin/aboutus/wefocus",
    WhatOurCustomerSay: "/admin/aboutus/whatourcustomersay",
    ManBehindPower: "/admin/aboutus/manbehindpower"
  },


  //Customizations
  Customizations: {
    AppSetup: "/admin/customizations/appsetup"
  },

  powerprogress: {
    powerprogress: "/admin/powerprogresses/powerprogress"
  },


  //SubsidyPolicys
  SubsidyPolicys: {
    SubsidyBanner: "/admin/subsidypolicys/subsidybanner",
    NewUpdate: "/admin/subsidypolicys/newupdate",
    SubsidyBenefit: "/admin/subsidypolicys/subsidybenefit",
    SubsidyRegistrationProcess: "/admin/subsidypolicys/subsidyregistrationprocess",
    LatestAnnouncement: "/admin/subsidypolicys/latestannouncement",
    Electricity: "/admin/subsidypolicys/electricity",
    RooftopSolar: "/admin/subsidypolicys/rooftopsolar"
  },


  //PrivacyPolicys
  PrivacyPolicys: {
  PrivacyPolicy: "/admin/privacypolicys/privacypolicy"
  },


  //Terms of service
  TermsOfServices: {
  TermsOfService: "/admin/termsofservices/termsofservice"
  },


  //Home page
  HomePage: {
    HomeBanner: "/admin/homepage/homebanner",
    EverySpace: "/admin/homepage/everyspace",
    Location: "/admin/homepage/location"
  },

  Contactuss: {
    ContactUs: "/admin/contactuss/contactus"
  },

  FreeConsultations: {
    FreeConsultation: "/admin/freeconsultations/freeconsultation"
  },


  //Gallerys
  Gallerys: {
    Gallery: "/admin/gallerys/gallery",
  },




  //common
  Commons: {
    AllCountry: "/common/masters/all-country",
    AllState: "/common/masters/all-state",
    AllCity: "/common/masters/all-city",
    AllPincode: "/common/masters/all-pincode",

    AllFAQ: "/common/faqs/all-faq",

    AllPopularTag: "/common/blogs/all-populartag",

    AllServiceInclude: "/common/services/all-serviceinclude",

    AllKeyBenefit: "/common/services/all-keybenefit",

    AllBanner: "/common/aboutus/all-banner",

    AllVisionMission: "/common/aboutus/all-visionmission",

    AllWhyChooseUs: "/common/aboutus/all-whychooseus",

    AllPeopleBehindwork: "/common/aboutus/all-peoplebehindwork",

    AllWhyWeRank: "/common/aboutus/all-whywerank",

    AllWhatMakeDifferent: "/common/aboutus/all-whatmakedifferent",

    AllWeFocus: "/common/aboutus/all-wefocus",

    AllWhatOurCustomerSay: "/common/aboutus/all-whatourcustomersay",

    AllManBehindPower: "/common/aboutus/all-manbehindpower",

    AllBestFor: "/common/services/all-bestfor",

    AllService: "/common/services/all-service",

    AllAppSetup: "/common/customizations/all-appsetup",

    AllAvgMonthlyBill: "/common/masters/all-avgmonthlybill",

    AllTrustedAcrossCommunity: "/common/masters/all-trustedacrosscommunity",

    AllBlog: "/common/blogs/all-blog",

    AllSubsidyBanner: "/common/subsidypolicys/all-subsidybanner",

    AllNewUpdate: "/common/subsidypolicys/all-newupdate",

    AllSubsidyBenefit: "/common/subsidypolicys/all-subsidybenefit",

    AllSubsidyRegistrationProcess: "/common/subsidypolicys/all-subsidyregistrationpprocess",

    AllPrivacyPolicy: "/common/privacypolicys/all-privacypolicy",

    AllTermsOfService: "/common/termsofservices/all-termsofservice",

    AllHomeBanner: "/common/homepage/all-homebanner",

    AllEverySpace: "/common/homepage/all-everyspace",

    AllGallery: "/common/gallerys/all-gallery",

    AllFAQCategory: "/common/faqs/all-faqcategory",

    AllTotalServices: "/common/dashboard/all-totalservices",

    AllContactUs: "/common/contactuss/all-contactus",

    AllFreeConsultation: "/common/freeconsultations/all-freeconsultation",

    AllLatestAnnouncement: "/common/subsidypolicys/all-latestannouncement",

    AllElectricity: "/common/subsidypolicys/all-electricity",

    AllRooftopSolar: "/common/subsidypolicys/all-rooftopsolar"
  },


  // Dashboard
  Dashboard: {
    dashboard: "/admin/dashboard/totalservices",
  },
};
